(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-compare-images")) {
  customElements.define(
    "s-compare-images",
    class SectioCompareImages extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.slider = this.querySelector('.js-compare-images__slider');
        this.before = this.querySelector('.js-compare-images__before-image');
        this.beforeImage = this.before.querySelector('img');
        this.resizer = this.querySelector('.js-compare-images__resizer');

        this.active = false;

        document.addEventListener("DOMContentLoaded", () => {
          let width = this.slider.offsetWidth;
          this.beforeImage.style.width = width + 'px';
        });

        //Adjust width of image on resize 
        window.addEventListener('resize', () => {
          let width = this.slider.offsetWidth;
          this.beforeImage.style.width = width + 'px';
        })

        this.resizer.addEventListener('mousedown', () => {
          this.active = true;
          this.resizer.classList.add('resize');
        });

        document.body.addEventListener('mouseup', () => {
          this.active = false;
          this.resizer.classList.remove('resize');
        });

        document.body.addEventListener('mouseleave',  () =>  {
          this.active = false;
          this.resizer.classList.remove('resize');
        });

        document.body.addEventListener('mousemove', (e) => {
          if (!this.active) return;
          let x = e.pageX;
          x -= this.slider.getBoundingClientRect().left;
          this.slideIt(x);
          this.pauseEvent(e);
        });

        this.resizer.addEventListener('touchstart', () => {
          this.active = true;
          this.resizer.classList.add('resize');
        });

        document.body.addEventListener('touchend', () => {
          this.active = false;
          this.resizer.classList.remove('resize');
        });

        document.body.addEventListener('touchcancel', () => {
          this.active = false;
          this.resizer.classList.remove('resize');
        });

        //calculation for dragging on touch devices
        document.body.addEventListener('touchmove', (e) => {
          if (!this.active) return;
          let x;
          
          let i;
          for (i=0; i < e.changedTouches.length; i++) {
          x = e.changedTouches[i].pageX; 
          }
          
          x -= this.slider.getBoundingClientRect().left;
          this.slideIt(x);
          this.pauseEvent(e);
        });

      }

      disconnectedCallback() {
      }

      slideIt = (x) => {
        let transform = Math.max(0,(Math.min(x,this.slider.offsetWidth)));
        this.before.style.width = transform+"px";
        this.resizer.style.left = transform-0+"px";
      }
      
      //stop divs being selected.
      pauseEvent = (e) => {
        if(e.stopPropagation) e.stopPropagation();
        if(e.preventDefault) e.preventDefault();
        e.cancelBubble=true;
        e.returnValue=false;
        return false;
      }
    }
  );
}
},{}]},{},[1])

